// extracted by mini-css-extract-plugin
export default {"errorText":"error-text_errorText__5OZgv"};